export default __webpack_public_path__ + "static/media/bdswissGlobalReal02_downloadMT4.e8971a1e.png";